import { createValidationSchema, enumField, isError, stringField, uuidField, ValidationError, } from "@for-it/domain-lib";
import { TenantEntity } from "../../entities/tenant.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
export const TENANT_ASSET_KINDS = ["logo", "favicon"];
const ALLOWED_CONTENT_TYPES = {
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/webp": "webp",
    "image/x-icon": "ico",
    "image/vnd.microsoft.icon": "ico",
};
const MAX_BYTES = 2 * 1024 * 1024; // 2MB
export const uploadTenantAsset = {
    name: "uploadTenantAsset",
    description: "Uploads a logo or favicon to the tenant's bucket and returns the public URL.",
    type: "command",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        tenantId: uuidField({
            required: true,
            message: "Debe ingresar un ID de tenant válido",
        }),
        kind: enumField(TENANT_ASSET_KINDS, {
            required: true,
            message: "Debe especificar el tipo de asset (logo o favicon)",
        }),
        contentType: stringField({
            required: true,
            message: "El content-type es obligatorio",
        }),
        base64Data: stringField({
            required: true,
            message: "El contenido del archivo es obligatorio",
        }),
    }),
    useCase: async ({ db, tenantAssetUploadService }, payload) => {
        // Input-validation failures below are client errors (HTTP 400), so
        // they return a ValidationError rather than UnexpectedError (500).
        const extension = ALLOWED_CONTENT_TYPES[payload.contentType];
        if (!extension) {
            return new ValidationError({
                contentType: "Formato no soportado. Usá PNG, JPG, WEBP o ICO.",
            });
        }
        const tenant = await db.findOne(TenantEntity, {
            where: { id: payload.tenantId },
        });
        if (!tenant)
            return new TenantNotFoundError();
        const cleaned = payload.base64Data.replace(/^data:[^;]+;base64,/, "");
        const buffer = Buffer.from(cleaned, "base64");
        if (buffer.length === 0) {
            return new ValidationError({
                base64Data: "El contenido del archivo está vacío.",
            });
        }
        if (buffer.length > MAX_BYTES) {
            return new ValidationError({
                base64Data: "El archivo no debe superar los 2MB.",
            });
        }
        const bucketName = `amia-tenant-${tenant.subdomain}`;
        const key = `${payload.kind}-${Date.now()}.${extension}`;
        const result = await tenantAssetUploadService.upload({
            bucketName,
            key,
            contentType: payload.contentType,
            body: buffer,
        });
        if (isError(result))
            return result;
        return { url: result.url };
    },
};
